import { getFromLocalStorage, saveToLocalStorage } from '/@/utils/localStorage';
import { contentPaneRoutes } from '/@/app/routes';


const SCROLLS_LOCAL_STORAGE_KEY = "AppScrollPositions";
export const getScrollsFromLocalStorage = () => {
    return getFromLocalStorage(SCROLLS_LOCAL_STORAGE_KEY, {});
}
export const getScrollFromLocalStorage = (path) => {
    let scroll = getScrollsFromLocalStorage()[path];
    if (scroll === undefined) {
        return 0
    }
    return scroll;
}
export const saveScrollToLocalStorage = (path, value) => {
    let scrolls = getScrollsFromLocalStorage();
    scrolls[path] = value;
    saveToLocalStorage(SCROLLS_LOCAL_STORAGE_KEY, scrolls);
}

export const resetScrollsOnCalculate = () => {
    // run it automatically on when results recalculated
    for (let route of contentPaneRoutes) {
        if (route._resetScrollOnCalculate) {
            saveScrollToLocalStorage(route.path, 0);
        }
    }
    console.log('Scrolls reset.');
}
